import { OrderSummaryItem } from "components/UI/organisms";
import "./index.scss";
import { OrderReceipt } from "components/UI/molecules";

export const OrderSummary = ({ cards, totals, isApple = false }) => {
  return (
    <div className="order-summary">
      <h3 className="order-summary-title">Your Order Summary</h3>

      {cards.map((item) => {
        const isLettuce = item.brand_slug === "lettuce-entertain-you";
        return (
          <OrderSummaryItem
            key={item.card_id}
            {...item}
            isLettuce={isLettuce}
            isApple={isApple}
          />
        );
      })}

      <OrderReceipt totals={totals} />
    </div>
  );
};
